module.exports = "/_next/static/images/e8a33bbfff2e0452c82462c55b49bddb-merchant.svg.webp";